// src/components/BillingAddressForm.js — AVS Cloud | §14 UStG Rechnungsadresse
// FIX: Field-Inputs inline statt als innere Komponente (verhindert Focus-Verlust)
import React, { useState, useEffect } from 'react';

const COUNTRIES = [
  { code: 'DE', name: 'Deutschland' },
  { code: 'AT', name: 'Österreich' },
  { code: 'CH', name: 'Schweiz' },
  { code: 'BE', name: 'Belgien' },
  { code: 'BG', name: 'Bulgarien' },
  { code: 'CY', name: 'Zypern' },
  { code: 'CZ', name: 'Tschechien' },
  { code: 'DK', name: 'Dänemark' },
  { code: 'EE', name: 'Estland' },
  { code: 'ES', name: 'Spanien' },
  { code: 'FI', name: 'Finnland' },
  { code: 'FR', name: 'Frankreich' },
  { code: 'GB', name: 'Vereinigtes Königreich' },
  { code: 'GR', name: 'Griechenland' },
  { code: 'HR', name: 'Kroatien' },
  { code: 'HU', name: 'Ungarn' },
  { code: 'IE', name: 'Irland' },
  { code: 'IT', name: 'Italien' },
  { code: 'LT', name: 'Litauen' },
  { code: 'LU', name: 'Luxemburg' },
  { code: 'LV', name: 'Lettland' },
  { code: 'MT', name: 'Malta' },
  { code: 'NL', name: 'Niederlande' },
  { code: 'PL', name: 'Polen' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Rumänien' },
  { code: 'SE', name: 'Schweden' },
  { code: 'SI', name: 'Slowenien' },
  { code: 'SK', name: 'Slowakei' },
];

function validateZip(zip, country) {
  if (!zip) return false;
  const cleaned = zip.trim();
  if (country === 'DE') return /^\d{5}$/.test(cleaned);
  if (country === 'AT' || country === 'CH') return /^\d{4}$/.test(cleaned);
  return cleaned.length >= 3 && cleaned.length <= 10;
}

const s = {
  wrap: {},
  title: { fontSize: '0.95rem', fontWeight: 700, color: 'var(--cyan)', fontFamily: 'var(--font-head)', marginBottom: '1.25rem' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' },
  full: { gridColumn: '1 / -1' },
  label: { display: 'block', fontSize: '0.72rem', fontWeight: 600, color: 'var(--muted)', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.35rem' },
  input: { display: 'block', width: '100%', padding: '0.65rem 0.9rem', background: 'rgba(255,255,255,0.05)', border: '1px solid var(--border)', borderRadius: '6px', color: 'var(--white)', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s', fontFamily: 'inherit' },
  inputError: { borderColor: 'rgba(255, 80, 80, 0.5)' },
  select: { display: 'block', width: '100%', padding: '0.65rem 0.9rem', background: 'rgba(255,255,255,0.07)', border: '1px solid var(--border)', borderRadius: '6px', color: 'var(--white)', fontSize: '0.88rem', outline: 'none', boxSizing: 'border-box', cursor: 'pointer', fontFamily: 'inherit' },
  errorText: { fontSize: '0.72rem', color: '#ff8888', marginTop: '0.3rem' },
  actions: { display: 'flex', gap: '0.75rem', marginTop: '1.25rem' },
  saveBtn: { flex: 1, padding: '0.75rem 1.25rem', background: 'var(--cyan)', border: 'none', borderRadius: '7px', color: '#0a0a0a', fontWeight: 700, fontSize: '0.88rem', cursor: 'pointer', fontFamily: 'var(--font-head)', letterSpacing: '0.02em', transition: 'opacity 0.2s' },
  cancelBtn: { padding: '0.75rem 1.25rem', background: 'transparent', border: '1px solid var(--border)', borderRadius: '7px', color: 'var(--muted)', fontWeight: 600, fontSize: '0.88rem', cursor: 'pointer', fontFamily: 'inherit' },
  successMsg: { fontSize: '0.82rem', color: '#4ade80', marginTop: '0.75rem', padding: '0.6rem 0.9rem', background: 'rgba(74, 222, 128, 0.08)', border: '1px solid rgba(74, 222, 128, 0.25)', borderRadius: '6px' },
  errorMsg: { fontSize: '0.82rem', color: '#ff8888', marginTop: '0.75rem', padding: '0.6rem 0.9rem', background: 'rgba(255, 80, 80, 0.08)', border: '1px solid rgba(255, 80, 80, 0.25)', borderRadius: '6px' },
};

export default function BillingAddressForm({ initialData = {}, onSave, onCancel, isLoading = false, showTitle = true }) {
  const [form, setForm] = useState({
    billing_firstname: initialData.billing_firstname || '',
    billing_lastname: initialData.billing_lastname || '',
    billing_street: initialData.billing_street || '',
    billing_zip: initialData.billing_zip || '',
    billing_city: initialData.billing_city || '',
    billing_country: initialData.billing_country || 'DE',
  });

  const [touched, setTouched] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setForm({
        billing_firstname: initialData.billing_firstname || '',
        billing_lastname: initialData.billing_lastname || '',
        billing_street: initialData.billing_street || '',
        billing_zip: initialData.billing_zip || '',
        billing_city: initialData.billing_city || '',
        billing_country: initialData.billing_country || 'DE',
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const set = (field, value) => {
    setForm(f => ({ ...f, [field]: value }));
    setSubmitError('');
    setSubmitSuccess('');
  };

  const touch = (field) => setTouched(t => ({ ...t, [field]: true }));

  const errors = {
    billing_firstname: !form.billing_firstname.trim() ? 'Pflichtfeld' : '',
    billing_lastname: !form.billing_lastname.trim() ? 'Pflichtfeld' : '',
    billing_street: !form.billing_street.trim() ? 'Pflichtfeld' : '',
    billing_zip: !validateZip(form.billing_zip, form.billing_country)
      ? form.billing_country === 'DE' ? '5-stellige PLZ erforderlich'
        : (form.billing_country === 'AT' || form.billing_country === 'CH') ? '4-stellige PLZ erforderlich'
        : 'Ungültige PLZ'
      : '',
    billing_city: !form.billing_city.trim() ? 'Pflichtfeld' : '',
  };

  const isValid = Object.values(errors).every(e => !e);

  const handleSubmit = async () => {
    setTouched({ billing_firstname: true, billing_lastname: true, billing_street: true, billing_zip: true, billing_city: true });
    if (!isValid) return;
    setSaving(true);
    setSubmitError('');
    setSubmitSuccess('');
    try {
      if (onSave) {
        await onSave(form);
        setSubmitSuccess('Rechnungsadresse gespeichert.');
      }
    } catch (err) {
      setSubmitError(err.message || 'Fehler beim Speichern.');
    } finally {
      setSaving(false);
    }
  };

  const isDisabled = isLoading || saving;

  const zipLabel = form.billing_country === 'DE' ? 'PLZ (5-stellig)' : (form.billing_country === 'AT' || form.billing_country === 'CH') ? 'PLZ (4-stellig)' : 'PLZ';
  const zipPlaceholder = form.billing_country === 'DE' ? '76437' : form.billing_country === 'AT' ? '1010' : form.billing_country === 'CH' ? '8001' : '';

  return (
    <div style={s.wrap}>
      {showTitle && <h3 style={s.title}>Rechnungsadresse (§ 14 UStG)</h3>}

      <div style={s.grid}>
        {/* Vorname */}
        <div>
          <label style={s.label} htmlFor="billing_firstname">Vorname *</label>
          <input
            id="billing_firstname"
            type="text"
            style={{ ...s.input, ...(touched.billing_firstname && errors.billing_firstname ? s.inputError : {}) }}
            placeholder="Max"
            value={form.billing_firstname}
            onChange={e => set('billing_firstname', e.target.value)}
            onBlur={() => touch('billing_firstname')}
            autoComplete="given-name"
            disabled={isDisabled}
          />
          {touched.billing_firstname && errors.billing_firstname && <div style={s.errorText}>{errors.billing_firstname}</div>}
        </div>

        {/* Nachname */}
        <div>
          <label style={s.label} htmlFor="billing_lastname">Nachname *</label>
          <input
            id="billing_lastname"
            type="text"
            style={{ ...s.input, ...(touched.billing_lastname && errors.billing_lastname ? s.inputError : {}) }}
            placeholder="Mustermann"
            value={form.billing_lastname}
            onChange={e => set('billing_lastname', e.target.value)}
            onBlur={() => touch('billing_lastname')}
            autoComplete="family-name"
            disabled={isDisabled}
          />
          {touched.billing_lastname && errors.billing_lastname && <div style={s.errorText}>{errors.billing_lastname}</div>}
        </div>

        {/* Straße */}
        <div style={s.full}>
          <label style={s.label} htmlFor="billing_street">Straße & Hausnummer *</label>
          <input
            id="billing_street"
            type="text"
            style={{ ...s.input, ...(touched.billing_street && errors.billing_street ? s.inputError : {}) }}
            placeholder="Musterstraße 1"
            value={form.billing_street}
            onChange={e => set('billing_street', e.target.value)}
            onBlur={() => touch('billing_street')}
            autoComplete="street-address"
            disabled={isDisabled}
          />
          {touched.billing_street && errors.billing_street && <div style={s.errorText}>{errors.billing_street}</div>}
        </div>

        {/* PLZ */}
        <div>
          <label style={s.label} htmlFor="billing_zip">{zipLabel} *</label>
          <input
            id="billing_zip"
            type="text"
            style={{ ...s.input, ...(touched.billing_zip && errors.billing_zip ? s.inputError : {}) }}
            placeholder={zipPlaceholder}
            value={form.billing_zip}
            onChange={e => set('billing_zip', e.target.value)}
            onBlur={() => touch('billing_zip')}
            autoComplete="postal-code"
            disabled={isDisabled}
          />
          {touched.billing_zip && errors.billing_zip && <div style={s.errorText}>{errors.billing_zip}</div>}
        </div>

        {/* Stadt */}
        <div>
          <label style={s.label} htmlFor="billing_city">Stadt *</label>
          <input
            id="billing_city"
            type="text"
            style={{ ...s.input, ...(touched.billing_city && errors.billing_city ? s.inputError : {}) }}
            placeholder="Rastatt"
            value={form.billing_city}
            onChange={e => set('billing_city', e.target.value)}
            onBlur={() => touch('billing_city')}
            autoComplete="address-level2"
            disabled={isDisabled}
          />
          {touched.billing_city && errors.billing_city && <div style={s.errorText}>{errors.billing_city}</div>}
        </div>

        {/* Land */}
        <div style={s.full}>
          <label style={s.label} htmlFor="billing_country">Land</label>
          <select
            id="billing_country"
            style={s.select}
            value={form.billing_country}
            onChange={e => set('billing_country', e.target.value)}
            disabled={isDisabled}
          >
            {COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.name}</option>)}
          </select>
        </div>
      </div>

      {submitError && <div style={s.errorMsg}>{submitError}</div>}
      {submitSuccess && <div style={s.successMsg}>✓ {submitSuccess}</div>}

      <div style={s.actions}>
        <button
          style={{ ...s.saveBtn, opacity: isDisabled ? 0.5 : 1 }}
          onClick={handleSubmit}
          disabled={isDisabled}
        >
          {saving ? 'Speichert…' : 'Adresse speichern'}
        </button>
        {onCancel && (
          <button style={s.cancelBtn} onClick={onCancel} disabled={isDisabled}>
            Abbrechen
          </button>
        )}
      </div>
    </div>
  );
}
